import AnalogStagePedalModelLarge from "./analogStagePedalModelLarge";
import {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";


function AnalogStagePedal(props) {
    const [version, setVersion] = useState('standard');
    const [price, setPrice] = useState('$300');
    const [color, setColor] = useState('surfGreen');
    const [jacks, setJacks] = useState('side');
    const [paymentLink, setPaymentLink] = useState('https://buy.stripe.com/5kQ5kD9of4QLfi738i7EQ0m');
    const [currentDate, setCurrentDate] = useState(new Date());
    const [formData, setFormData] = useState({ name: '', version: 'standard', date: ''});


   
    
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value});
        console.log(formData);
      };

      const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Data needs to be sent as URL parameters for the simple doPost function above
            const params = new URLSearchParams(formData).toString();
            const response = await fetch(`${scriptUrl}?${params}`, {
              method: 'POST',
              mode: 'no-cors' // Bypasses the CORS restriction
            });
            
            // Even if successful, 'no-cors' mode means response.ok will be false. 
            // The script will run in the background.
            console.log('Form submitted (cannot confirm success due to no-cors mode)');
            alert('Form submitted successfully!'); // Show a success message to the user
            setFormData({ name: '', version: 'standard', date: ''});
            window.location.href = paymentLink;
            
          } catch (error) {
            console.error('Error:', error.message);
            alert('Form submission failed!');
          }
            
      };

     

      const scriptUrl = 'https://script.google.com/macros/s/AKfycbzox_tlU52vvJ_BKWB36PY4D5znYGSUJBajVsqTgs7GvDKc9wBRifKw3TcFEz3ZnxN9uQ/exec';
    

    useEffect(() => {
        if (formData.version == 'standard') {
            setPaymentLink('https://buy.stripe.com/5kQ5kD9of4QLfi738i7EQ0m');
        } else if (formData.version == 'xlrOut') {
            setPaymentLink('https://buy.stripe.com/fZu9AT8kbbf96LB5gq7EQ0n');
        }
    }, [formData]);

    

   
   

    useEffect(() => {
        if (formData.version === 'standard') {
            setPrice('$299');
        } else if (formData.version === 'xlrOut') {
            setPrice('$319');
        }
    }, [formData]);


    


    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '40px'
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                width: '100%',
                justifyContent: 'center',
                columnGap: '50px'
            }}>
            <div style={{
                width: '350px',
            }}>
            <img src={props.products[1].photo} style={{
                width: '100%',
                borderRadius: '10px'
            }}></img>
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '50%',
                textAlign: 'center'
                
            }}>
            <h1 style={{
                color: '#414243'
            }}>{props.products[1].name}</h1>
            <h2 style={{
                color: '#414243'
            }}>{price}</h2>
            <p style={{
                color: '#414243'
            }}>{props.products[1].description}</p>
            <div>
                <form method="POST" action={scriptUrl} onSubmit={handleSubmit} style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
                justifyItems: 'center',
                alignItems: 'center',
                rowGap: '20px'
            }}>
            <input name="name" placeholder="name" value={formData.name} onChange={handleChange} required></input>
            <select name="version" value={formData.version} onChange={handleChange} style={{
                width: '80%'
            }}>
                <option value='standard'>standard (no xlr out)</option>
                <option value ='xlrOut'>xlr DI out</option>
            </select>
            <input name="date" placeholder="date" value={formData.date} onChange={handleChange} required></input>

            <button style={{
                width: '50%',
                marginLeft: '0px'
            }}>Buy Now</button>
            
            </form>
            </div>
            </div>
            </div>
            <div style={{
                width: '100%',
                height: '400px',
                marginTop: '100px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                //border: '1px solid black'
            }}>
            {/* <AnalogStagePedalModelLarge color = {color} formData = {formData}/> */}
            </div>
        </div>
    )
}

export default AnalogStagePedal;